var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.601c0-.563.183-1.023.55-1.378.375-.365.85-.547 1.425-.547.6 0 1.087.182 1.462.547.375.355.563.815.563 1.378 0 .546-.188 1.002-.563 1.366-.366.355-.854.533-1.462.533-.575 0-1.05-.178-1.425-.533-.367-.364-.55-.82-.55-1.366Zm.462-16.101h3.088l-.338 11.575h-2.424L18.462 11.5Z",
    fill: "#1D352A"
  })));
};
export default SvgAlert;